import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogData } from './confirm.service';

@Component({
  selector: 'confirm-dialog',
  template: `
    @if(data.title){<h2 mat-dialog-title>{{ data.title }}</h2>}
    <mat-dialog-content>
      <p class="tw-whitespace-pre-line">{{ data.message }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      @if(data.cancelText){<button mat-button [mat-dialog-close]="false" >{{ data.cancelText }}</button>}
      <button mat-flat-button [mat-dialog-close]="true" >{{ data.confirmText || 'OK' }}</button>
    </mat-dialog-actions>
  `
})
export class ConfirmDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
    public dialogRef: MatDialogRef<ConfirmDialogComponent>
  ) { }
}
